import controller from './thing-folders.controller';

const template = require('./thing-folders.html');

export default {
    bindings: {
        reset: '<',
        addItemToBucket: '&',
        removeItemFromBucket: '&'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-folders/thing-folders.component.js